<template>
  <div class="container row">
    <table class="table table-borderless">
      <tbody class="body">
        <tr>
          <td class="col-6 head">Transfer Batch No. </td>
          <td class="col-6 head">Content Type</td>
        </tr>
        <tr>
          <td
            v-if="transferStore.currentTransfer.batchNumber == ''"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ transferStore.currentTransfer.batchNumber }}
          </td>
          <td
            v-if="contentStore.currentContent?.contentType == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ contentStore.currentContent?.contentType }}
          </td>
        </tr>
        <tr>
          <td class="head">Date Received</td>
          <td class="head">Structure Type</td>
        </tr>
        <tr>
          <td class="content">
            {{
              $filters.formatDateAndTime(
                transferStore.currentTransfer.depositedAt
              )
            }}
          </td>
          <td
            v-if="transferStore.currentTransfer.structureType == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ transferStore.currentTransfer.structureType }}
          </td>
        </tr>
        <tr>
          <td class="head">Total No. of Files</td>
          <td class="head">Total Batch Size</td>
        </tr>
        <tr>
          <td
            v-if="transferStore.currentTransfer.fileCount == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ transferStore.currentTransfer.fileCount }}
          </td>
          <td class="content">
            {{
              $filters.formatSizeUnits(
                transferStore.currentTransfer.totalTransferSize
              )
            }}
          </td>
        </tr>
        <tr>
          <td class="head">Transfer Status</td>
          <td class="head">Transferring Agency</td>
        </tr>
        <tr>
          <td
            v-if="transferStore.currentTransfer.status == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ transferStore.currentTransfer.status }}
          </td>
          <td
            v-if="transferStore.currentTransfer.transferringAgency == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ transferStore.currentTransfer.transferringAgency }}
          </td>
        </tr>
        <tr>
          <td class="head">Transfer Date</td>
          <td class="head">No. of SIPs</td>
        </tr>
        <tr>
          <td class="content">
            {{
              $filters.formatDate(transferStore.currentTransfer.transferDate)
            }}
          </td>
          <td
            v-if="transferStore.currentTransfer.sipCount == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ transferStore.currentTransfer.sipCount }}
          </td>
        </tr>
        <tr>
          <td class="head">Transfer Exception Details</td>
          <td class="head">Package Name</td>
        </tr>
        <tr>
          <td class="content">
            <tr>
              <span v-if="transferStore.currentTransfer.warningCount != null">
                <span
                  class="transfer-exception-modal"
                  data-bs-toggle="modal"
                  data-bs-target="#transferExceptionWarningModal"
                  @click="changeStyle"
                  >{{
                    transferStore.currentTransfer.warningCount
                  }}
                  Warning</span
                >
              </span>
              <span v-else
                ><span class="transfer-exception-modal-cursor"
                  >0 Warning</span
                ></span
              >
            </tr>
            <tr>
              <span
                v-if="transferStore.currentTransfer.criticalErrorCount != null"
              >
                <span
                  class="transfer-exception-modal"
                  data-bs-toggle="modal"
                  data-bs-target="#transferExceptionCriticalModal"
                  @click="changeStyle"
                  >{{
                    transferStore.currentTransfer.criticalErrorCount
                  }}
                  Critical Error</span
                >
              </span>
              <span v-else
                ><span class="transfer-exception-modal-cursor"
                  >0 Critical Error</span
                ></span
              >
            </tr>
            <tr>
              <span
                v-if="
                  transferStore.currentTransfer.noncriticalErrorCount != null
                "
              >
                <span
                  class="transfer-exception-modal"
                  data-bs-toggle="modal"
                  data-bs-target="#transferExceptionNonCriticalModal"
                  @click="changeStyle"
                  >{{
                    transferStore.currentTransfer.noncriticalErrorCount
                  }}
                  Non-Critical Error</span
                >
              </span>
              <span v-else
                ><span class="transfer-exception-modal-cursor"
                  >0 Non-Critical Error</span
                ></span
              >
            </tr>
          </td>
          <td
            v-if="!transferStore.currentTransfer.name == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ transferStore.currentTransfer.name }}
          </td>
        </tr>
        <tr>
          <td class="head">Highest Security Grading</td>
          <td class="head">Highest Sensitivity Classification</td>
        </tr>
        <tr>
          <td
            v-if="transferStore.currentTransfer.highestSecurityGrading == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ transferStore.currentTransfer.highestSecurityGrading }}
          </td>
          <td
            v-if="
              transferStore.currentTransfer.highestSensitivityClassification ==
              null
            "
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ transferStore.currentTransfer.highestSensitivityClassification }}
          </td>
        </tr>
        <tr>
          <td class="head">Deposit Location</td>
        </tr>
        <tr>
          <td
            v-if="contentStore.currentContent.depositLocation == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ contentStore.currentContent.depositLocation }}
          </td>
        </tr>
        <!-- <tr>
          <td class="head">Batch Status Detail</td>
          <td></td>
        </tr>
        <tr>
          <td class="content">{{ transferStore.currentTransfer.status }}</td>
          <td></td>
        </tr> -->
        <tr
          v-show="
            transferStore.currentTransfer.status == 'Pending Review' &&
            transferStore.currentTransfer.note
          "
        >
          <td class="head">
            <div class="row">
              <div class="col-sm-5">Batch Note</div>
              <div class="col-sm-3">
                <span
                  class="btn btn-edit"
                  data-bs-toggle="modal"
                  data-bs-target="#addBatchNoteModal"
                  @click="changeStyle"
                  ><i class="material-icons">edit</i>Edit</span
                >
              </div>
              <div class="col-sm-4">
                <span
                  class="btn btn-delete"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteBatchNoteModal"
                  @click="changeStyle"
                  ><i class="material-icons">delete</i>Delete</span
                >
              </div>
            </div>
          </td>
          <td></td>
        </tr>
        <tr
          v-show="
            transferStore.currentTransfer.status == 'Pending Review' &&
            !transferStore.currentTransfer.note
          "
        >
          <td class="head">Batch Note</td>
          <td></td>
        </tr>
        <tr
          v-show="
            transferStore.currentTransfer.status == 'Pending Review' &&
            transferStore.currentTransfer.note
          "
        >
          <td class="content">{{ transferStore.currentTransfer.note }}</td>
          <td></td>
        </tr>
        <tr
          v-show="
            transferStore.currentTransfer.status == 'Pending Review' &&
            !transferStore.currentTransfer.note
          "
        >
          <td class="content">
            <button
              class="btn btn-outline-secondary"
              data-bs-toggle="modal"
              data-bs-target="#addBatchNoteModal"
              @click="changeStyle"
            >
              <i class="material-icons">add</i> Add Note
            </button>
          </td>
          <td></td>
        </tr>
        <!-- <tr
          v-show="
            transferStore.currentTransfer.status == 'Pending Review' &&
            transferStore.currentTransfer.note
          "
        >
          <td class="head">Batch Note Added By</td>
          <td class="head">Date and Time of Batch Note</td>
        </tr>
        <tr
          v-show="
            transferStore.currentTransfer.status == 'Pending Review' &&
            transferStore.currentTransfer.note
          "
        >
          <td class="content">
            {{ transferStore.currentTransfer.noteCreatedBy }}
          </td>
          <td class="content">
            {{
              $filters.formatDateAndTime(
                transferStore.currentTransfer.noteCreatedAt
              )
            }}
          </td>
        </tr> -->
        <tr
          v-show="
            transferStore.currentTransfer.status != 'Pending Review' &&
            transferStore.currentTransfer.note
          "
        >
          <td class="head">Batch Note</td>
          <td></td>
        </tr>
        <tr
          v-show="
            transferStore.currentTransfer.status != 'Pending Review' &&
            transferStore.currentTransfer.note
          "
        >
          <td class="content">{{ transferStore.currentTransfer.note }}</td>
          <td></td>
        </tr>
        <tr v-show="transferStore.currentTransfer.note">
          <td class="head">Batch Note Added By</td>
          <td class="head">Date and Time of Batch Note</td>
        </tr>
        <tr v-show="transferStore.currentTransfer.note">
          <td class="content">
            {{ transferStore.currentTransfer.noteCreatedBy }}
          </td>
          <td class="content">
            {{
              $filters.formatDateAndTime(
                transferStore.currentTransfer.noteCreatedAt
              )
            }}
          </td>
        </tr>
        <tr
          v-show="containReport.includes(transferStore.currentTransfer.status)"
        >
          <td class="head">Report</td>
          <td></td>
        </tr>
        <tr
          v-show="containReport.includes(transferStore.currentTransfer.status)"
        >
          <td class="content">
            <button
              @click="showTransferReport"
              class="btn btn-outline-secondary"
            >
              <i class="material-icons">description</i> View Transfer Report
            </button>
          </td>
          <td></td>
        </tr>
        <tr v-show="containSips.includes(transferStore.currentTransfer.status) && transferStore.currentTransfer.sipCount>0">
          <td class="head">SIP Details</td>
          <td></td>
        </tr>
        <tr v-show="containSips.includes(transferStore.currentTransfer.status) && transferStore.currentTransfer.sipCount>0">
          <td class="content">
            <button @click="showSipReport" class="btn btn-outline-secondary">
              <i class="material-icons">open_in_new</i> View SIP Details
            </button>
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <span
      class="row border-top"
      v-show="
        contentStore.currentContent?.contentType == 'Transfer' &&
        contentStore.currentContent?.status == 'Identified' &&
        transferStore.currentTransfer.status == 'Pending Review'
      "
    >
      <button
        class="col btn btn-outline-secondary"
        data-bs-toggle="modal"
        data-bs-target="#retryTransferModal"
        style="margin-left: 10px; margin-top: 10px"
        @click="changeStyle"
        disabled
      >
        Retry
      </button>
      <button
        class="col btn btn-danger"
        data-bs-toggle="modal"
        data-bs-target="#rejectTransferModal"
        style="margin-left: 10px; margin-top: 10px"
        @click="changeStyle"
      >
        Reject
      </button>
      <button
        class="col btn btn-success"
        data-bs-toggle="modal"
        data-bs-target="#approveTransferModal"
        style="margin-left: 10px; margin-top: 10px"
        @click="changeStyle"
      >
        Approve
      </button>
    </span>
    <span
      hidden
      class="row border-top"
      v-show="
        contentStore.currentContent?.contentType == 'Transfer' &&
        contentStore.currentContent?.status == 'Identified' &&
        transferStore.currentTransfer.status == 'Failed'
      "
    >
      <button
        class="col btn btn-outline-secondary"
        data-bs-toggle="modal"
        data-bs-target="#retryTransferModal"
        style="margin-left: 10px; margin-top: 10px"
        @click="changeStyle"
        disabled
      >
        Retry
      </button>
      <button
        class="col btn btn-danger"
        data-bs-toggle="modal"
        data-bs-target="#rejectTransferModal"
        style="margin-left: 10px; margin-top: 10px"
        @click="changeStyle"
      >
        Reject
      </button>
    </span>
    <span
      class="row border-top"
      v-show="contentStore.currentContent?.contentType == 'Transfer' && 
      contentStore.currentContent?.status == 'Identified' && 
      transferStore.currentTransfer.status == 'SIP Creation Failed'"
    >
      <button
        class="col btn btn-outline-secondary"
        data-bs-toggle="modal"
        data-bs-target="#reprocessTransferModal"
        style="margin-left: 10px; margin-top: 10px"
        @click="changeStyle"
      >
        Reprocess Transfer
      </button>
      <button
        class="col btn btn-danger"
        data-bs-toggle="modal"
        data-bs-target="#cancelTransferModal"
        style="margin-left: 10px; margin-top: 10px"
        @click="changeStyle"
      >
        Cancel Transfer
      </button>
    </span>
    <span
      class="row border-top"
      v-show="contentStore.currentContent?.contentType == 'Transfer' && 
      contentStore.currentContent?.status == 'Identified' && 
      resubmitTransfer.includes(transferStore.currentTransfer.status)"
    >
      <button
        class="col btn btn-outline-secondary"
        data-bs-toggle="modal"
        data-bs-target="#resubmitTransferModal"
        style="margin-left: 10px; margin-top: 10px"
        @click="changeStyle"
      >
        Resubmit Transfer
      </button>
      <button
        class="col btn btn-danger"
        data-bs-toggle="modal"
        data-bs-target="#cancelTransferModal"
        style="margin-left: 10px; margin-top: 10px"
        @click="changeStyle"
      >
        Cancel Transfer
      </button>
    </span>
    <!-- <span
      class="row border-top"
      v-show="contentStore.currentContent?.contentType == 'Transfer' && 
      contentStore.currentContent?.status == 'Identified' && 
      transferStore.currentTransfer.status == 'SIP Processing Failed'"
    >
      <button
        class="col btn btn-danger"
        data-bs-toggle="modal"
        data-bs-target="#cancelTransferModal"
        style="margin-left: 10px; margin-top: 10px"
        @click="changeStyle"
      >
        Cancel Transfer
      </button>
    </span> -->
  </div>
  <note-modal :transfer-id="props.transferId" />
  <transfer-exception-modal :transfer-id="props.transferId" />
  <approve-reject-transfer-modal
    :transfer-id="props.transferId"
    :transfer-name="props.transferName"
  />
  <reprocess-resubmit-transfer-modal :transfer-id="props.transferId" />
</template>

<script lang="ts">
// use normal <script> to declare options
export default {
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import GlobalData from "@/GlobalData";
import ApproveRejectTransferModal from "@/components/Modal/ApproveRejectTransferModal.vue";
import ReprocessResubmitTransferModal from "@/components/Modal/ReprocessResubmitTransferModal.vue";
import NoteModal from "@/components/Modal/NoteModal.vue";
import TransferExceptionModal from "@/components/Modal/TransferExceptionModal.vue";
import { useContentStore } from "@/stores/content_review/content";
import { useTransferStore } from "@/stores/content_review/transfer";
import { useAsyncState } from "@vueuse/core";
import { watch, onMounted } from "vue";
import { useRouter } from "vue-router";

const transferStore: any = useTransferStore();
const contentStore: any = useContentStore();

const props = defineProps({
  transferId: { type: String, required: true },
  transferName: { type: String, required: true },
});
const containSips = [
  "Ready for Ingest",
  "Ingesting",
  "Packages Created",
  "Packages Sent to Storage",
  "Stored",
  "Report Created",
  "Failed",
  "SIP Submission Failed",
  "SIP Processing Failed",
  "SIP Upload Failed"
];

const resubmitTransfer = [
  "SIP Submission Failed",
  "SIP Processing Failed",
  "SIP Upload Failed"
]


const containReport = ["Stored", "Report Created", "Failed", "Rejected"];

onMounted(() => {
  let noteModal: any = document.getElementById("addBatchNoteModal");
  let deleteModal: any = document.getElementById("deleteBatchNoteModal");
  let transferExceptionWarningModal: any = document.getElementById(
    "transferExceptionWarningModal"
  );
  let transferExceptionCriticalModal: any = document.getElementById(
    "transferExceptionCriticalModal"
  );
  let transferExceptionNonCriticalModal: any = document.getElementById(
    "transferExceptionNonCriticalModal"
  );
  let rejectModal: any = document.getElementById("rejectTransferModal");
  let approveModal: any = document.getElementById("approveTransferModal");
  let retryModal: any = document.getElementById("approveTransferModal");
  let reprocessTransferModal: any = document.getElementById("reprocessTransferModal");
  let resubmitTransferModal: any = document.getElementById("resubmitTransferModal");
  let cancelTransferModal: any = document.getElementById("cancelTransferModal");

  noteModal.addEventListener("hidden.bs.modal", function () {
    GlobalData.getInstance().changeBatchPosition(
      "batch-layout",
      "border-start"
    );
  });
  deleteModal.addEventListener("hidden.bs.modal", function () {
    GlobalData.getInstance().changeBatchPosition(
      "batch-layout",
      "border-start"
    );
  });
  transferExceptionWarningModal.addEventListener(
    "hidden.bs.modal",
    function () {
      GlobalData.getInstance().changeBatchPosition(
        "batch-layout",
        "border-start"
      );
    }
  );
  transferExceptionCriticalModal.addEventListener(
    "hidden.bs.modal",
    function () {
      GlobalData.getInstance().changeBatchPosition(
        "batch-layout",
        "border-start"
      );
    }
  );
  transferExceptionNonCriticalModal.addEventListener(
    "hidden.bs.modal",
    function () {
      GlobalData.getInstance().changeBatchPosition(
        "batch-layout",
        "border-start"
      );
    }
  );
  rejectModal.addEventListener("hidden.bs.modal", function () {
    GlobalData.getInstance().changeBatchPosition(
      "batch-layout",
      "border-start"
    );
  });
  approveModal.addEventListener("hidden.bs.modal", function () {
    GlobalData.getInstance().changeBatchPosition(
      "batch-layout",
      "border-start"
    );
  });
  retryModal.addEventListener("hidden.bs.modal", function () {
    GlobalData.getInstance().changeBatchPosition(
      "batch-layout",
      "border-start"
    );
  });
  reprocessTransferModal.addEventListener("hidden.bs.modal", function () {
    GlobalData.getInstance().changeBatchPosition(
      "batch-layout",
      "border-start"
    );
  });
  resubmitTransferModal.addEventListener("hidden.bs.modal", function () {
    GlobalData.getInstance().changeBatchPosition(
      "batch-layout",
      "border-start"
    );
  });
  cancelTransferModal.addEventListener("hidden.bs.modal", function () {
    GlobalData.getInstance().changeBatchPosition(
      "batch-layout",
      "border-start"
    );
  });
});

watch(
  () => props.transferId,
  () => execute()
);

const { execute, error } = useAsyncState(() => {
  return transferStore.fetchTransfer(props.transferId);
}, null);

const router = useRouter();

const showSipReport = () => {
  router.push({
    name: "sip",
    params: { selectedTransferId: props.transferId },
  });
};

const showTransferReport = async () => {
  router.push({
    name: "transferreport",
    params: { selectedTransferId: props.transferId },
  });
};

// const showTransferReport = () => {
//   router.push({
//     name: "downloadreport",
//   });
// };

const changeStyle = () => {
  GlobalData.getInstance().changeBatchPosition("border-start", "batch-layout");
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  padding: 16px;
  min-width: 100%;
  overflow: auto;
}
.btn-edit {
  color: blue;
  font-weight: normal;
  height: fit-content;
  width: fit-content;
  padding: 0;
  border: none;
}
.btn-edit:hover {
  color: blue;
}
.btn-delete {
  color: red;
  font-weight: normal;
  height: fit-content;
  width: fit-content;
  padding: 0;
  border: none;
}
.btn-delete:hover {
  color: red;
}
.material-icons {
  display: inline-flex;
  vertical-align: top;
  font-size: 22px;
}
.transfer-exception-modal {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}
.transfer-exception-modal-cursor {
  cursor: text;
  color: blue;
  text-decoration: underline;
}
</style>
